import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzCtaBarVariant } from './sz-cta-bar.types';

@Component({
  selector: 'sz-cta-bar',
  templateUrl: './sz-cta-bar.component.html',
  styleUrls: ['./sz-cta-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzCtaBarComponent {
  readonly variant: InputSignal<SzCtaBarVariant> = input<SzCtaBarVariant>('sticky');
  readonly liftAboveTabbar: InputSignal<boolean> = input<boolean>(false);
}
